export const R_UZS_LABEL = 'RUB→UZS';
export const R_UZS_HINT = 'Заявка в рублях, зачисление в сумах на узбекскую карту';

export const hasRUzs = (paymentType?: string | null) => !!paymentType && paymentType.includes('R_UZS');

export const formatPaymentType = (paymentType?: string | null) =>
  paymentType ? paymentType.replace('R_UZS', R_UZS_LABEL) : paymentType;
